module.exports = __webpack_public_path__ + "a06a47da2c33bab54465a7fb470b5165.svg";